import { Pipe, PipeTransform } from '@angular/core';
import { StatusLoteMap as EnumAtivacao } from '../../pages/gestao-cartoes/ativacao-lote/enums/EStatusLoteEnum';
import { StatusLoteMap as EnumCarga } from '../importacao-lote/enums/EStatusLoteEnum';

@Pipe({ name: 'statusLote' })
export class StatusLoteEnumPipe implements PipeTransform {

  transform(value?: string, enumName?: string): string {
    if (value === null || value === undefined) {
      return '';
    }
    let type;
    if (enumName && enumName === 'CARGA') {
      type = EnumCarga[value];
    } else if (enumName && enumName === 'ATIVACAO') {
      type = EnumAtivacao[value];
    } else {
      type = EnumCarga[value];
    }

    return type ? type.label : '';
  }
}

@Pipe({ name: 'tipoCarga' })
export class TipoCargaEnumPipe implements PipeTransform {

  transform(value?: string): string {
    if (value === null || value === undefined) {
      return '';
    }
    switch (value) {
      case 'CARGA_CREDITO_FUNCIONARIO':
        return 'Carga funcionário';
      default:
        return '';
    }
  }
}
